import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./LogoutStyles";
import AuthPageBase from "./AuthPageBase";

const Auth0ErrorPage: React.FC = () => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const getErrorFromHash = () => {
      const hash = window.location.hash;
      if (hash.includes("?")) {
        const queryString = hash.split("?")[1];
        const urlParams = new URLSearchParams(queryString);
        const errorDescription = urlParams.get("error_description");
        if (errorDescription) {
          setErrorMessage(decodeURIComponent(errorDescription));
        }
      }
    };

    getErrorFromHash();
  }, []);

  const errorContent = (
    <Box className={classes.buttonContainer} sx={{ marginBottom: "120px" }}>
      <Typography variant="body1" className={classes.errorMessage}>
        {errorMessage}
      </Typography>
    </Box>
  );

  return (
    <AuthPageBase
      titleMessageId="auth0ErrorPage.title"
      titleDefaultMessage="Oops..."
      bodyMessageId="auth0ErrorPage.message"
      bodyDefaultMessage="An error occurred during login:"
      paperPadding="64px 30px"
      buttonContainerStyle={{}}
      buttonStyle={{ marginTop: "20px" }}
      loginWithErrorPage={true}
      additionalContent={errorContent}
    />
  );
};

export default Auth0ErrorPage;
